/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { MainContainer } from "./Country.styled";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../ProductsList.styled";
import {
  countryflagIcons as flagIcons,
  defaultCountryFlag,
} from "@utils/country-data";

const Country = (props) => {
  const { t, data, page } = props;
  return (
    <>
      {(data.status || page == "view") && (
        <DivBackgroundFullOpacity>
          <MainContainer>
            {data?.countryInfo?.id && (
              <Image
                src={
                  flagIcons[data.countryInfo.id]
                    ? flagIcons[data.countryInfo.id]
                    : defaultCountryFlag
                }
                alt="Avatar"
                title={t(data.countryInfo.name)}
                styles={{ width: page === "view" ? "56px" : "40px" }}
              />
            )}
          </MainContainer>
        </DivBackgroundFullOpacity>
      )}
      {page != "view" && !data.status && (
        <DivBackgroundLowOpacity>
          <MainContainer>
            {data?.countryInfo?.id && (
              <Image
                src={
                  flagIcons[data.countryInfo.id]
                    ? flagIcons[data.countryInfo.id]
                    : defaultCountryFlag
                }
                alt="Avatar"
                title={t(data.countryInfo.name)}
                styles={{ width: page === "view" ? "56px" : "40px" }}
              />
            )}
          </MainContainer>
        </DivBackgroundLowOpacity>
      )}
    </>
  );
};

Country.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

Country.defaultProps = {
  page: null,
};

export default withTranslation()(Country);
